'use strict';

import angular from 'angular';

/**
 * NavbarController - contrôleur de la barre de navigation
 */
export default angular.module('observatoireApp')
  .controller('NavbarController', ['$scope', '$rootScope', '$state', 'Auth', 'FavorisService', '$timeout', function($scope, $rootScope, $state, Auth, FavorisService, $timeout) {
      
      // Référence au contrôleur
      var vm = this;
      
      // État courant de l'utilisateur
      $scope.currentUser = null;
      $scope.nbFavoris = 0;
      
      // Vérifier l'authentification au chargement
      init();
      
      // Initialisation
      function init() {
        if (Auth.isAuthenticated()) {
          Auth.identity().then(function(user) {
            $scope.currentUser = user;
            
            // Mettre à jour le nombre de favoris
            $scope.nbFavoris = FavorisService.getFavoris().length;
          });
        }
      }
      
      // Fonction de déconnexion
      $scope.logout = function() {
        Auth.logout();
        $scope.currentUser = null;
        $scope.nbFavoris = 0;
        $state.go('home');
      };
      
      // Fonction pour ouvrir la connexion (version sans modal pour le moment)
      $scope.ouvrirModalConnexion = function() {
        alert('Pour utiliser cette fonctionnalité, veuillez vous connecter.');
        // Simuler une connexion réussie pour la démonstration
        $timeout(function() {
          // Simuler un utilisateur connecté
          Auth.setCurrentUser({ id: 1, username: 'demo_user', email: 'demo@example.com' });
          init(); // Réinitialiser après connexion
        }, 500);
      };
      
      // Écouter les événements de mise à jour des favoris
      $rootScope.$on('favoris:updated', function() {
        if (Auth.isAuthenticated()) {
          $scope.nbFavoris = FavorisService.getFavoris().length;
        }
      });
      
      // Écouter les événements d'authentification
      $rootScope.$on('auth:login-success', function() {
        init();
      });
      
      $rootScope.$on('auth:logout', function() {
        $scope.currentUser = null;
        $scope.nbFavoris = 0;
      });
    }]);
